var getBlockId = function getBlockId(block) {
  return block.data.get('id');
};

export default getBlockId;